import { Fragment, ReactNode, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { ROUTES } from 'src/constants/routes';
import { validateVerifyPolicyInputData } from 'src/pages/ComplianceProvider/utils/validate-verify-policy-input-data.util';
import { getVerifyPolicyInput } from 'src/redux/selectors/verifyPolicy';

interface ComplianceDataValidatorGuardProps {
  children: ReactNode;
}

export function ComplianceDataValidatorGuard({
  children,
}: ComplianceDataValidatorGuardProps) {
  const verifyPolicyInput = useSelector(getVerifyPolicyInput);
  const isValidQuoteData = useMemo(
    () => validateVerifyPolicyInputData(verifyPolicyInput),
    [verifyPolicyInput],
  );

  if (!isValidQuoteData) {
    return <Navigate to={ROUTES.COMPLIANCE_PATH} />;
  }

  return <Fragment>{children}</Fragment>;
}
